import { ShieldAlert, ShieldHalf, LucideIcon } from "lucide-react";
import { AbrangenciaMap, AbrangenciaNivelEnum } from "@workflow/types";
import { ProfileChip } from "./ProfileChip";

interface SecurityBlockProps {
  icon: LucideIcon;
  iconClassName: string;
  title: string;
  value: string;
}

function SecurityBlock({ icon: Icon, iconClassName, title, value }: SecurityBlockProps) {
  return (
    <div className="flex flex-col justify-between gap-2">
      <div className="space-y-1.5">
        <div className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          <Icon className={iconClassName} />
          <span>{title}</span>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <ProfileChip>{value}</ProfileChip>
        </div>
      </div>
      <span className="mt-1 block text-[10px] italic text-muted-foreground/85">
        Visível apenas para admin
      </span>
    </div>
  );
}

interface AdminSecurityPanelProps {
  abrangenciaNivel?: AbrangenciaNivelEnum;
  sensibilidadeNivel?: AbrangenciaNivelEnum;
}

/** Grid de Abrangência/Sensibilidade — renderizado apenas para admins. */
export function AdminSecurityPanel({
  abrangenciaNivel,
  sensibilidadeNivel,
}: AdminSecurityPanelProps) {
  return (
    <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
      {abrangenciaNivel !== undefined && (
        <SecurityBlock
          icon={ShieldAlert}
          iconClassName="w-3.5 h-3.5 text-amber-500/80 dark:text-amber-400/80"
          title="Abrangência"
          value={AbrangenciaMap[abrangenciaNivel]}
        />
      )}

      {sensibilidadeNivel !== undefined && (
        <SecurityBlock
          icon={ShieldHalf}
          iconClassName="w-3.5 h-3.5 text-indigo-500/80 dark:text-indigo-400/80"
          // ⚠️ Não existe SensibilidadeMap em @workflow/types; reutiliza AbrangenciaMap.
          title="Sensibilidade"
          value={AbrangenciaMap[sensibilidadeNivel]}
        />
      )}
    </div>
  );
}
